import { FilterBase } from './filter-base';
import { ListViewModelBase } from './list-view-model-base';
import { Subject, Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


export class ListComponentBase {

  public vm: ListViewModelBase;
  public filterChangeSubj: Subject<string>;
  public filterChange$: Observable<string>;
  public filterChanged: Subscription;
  constructor() { }

  public loadList(): Promise<void> { return Promise.reject('Not implemented'); }

  public wireUpSearchTextFilter() {

    this.filterChangeSubj = new Subject<string>();
    this.filterChange$ = this.filterChangeSubj.pipe(      
      debounceTime(1000),
      distinctUntilChanged(),
    );
    this.filterChanged = this.filterChange$.subscribe((value: string) => {
      this.filterBySearch(value);
    });

  }


  public filterBySearch(value: string): Promise<void> {
    this.vm.filter.search = value;
    this.vm.filter.skip = 0;
    return this.loadList();
  }

  public onSort(event: any, field: string) {

    if (this.vm.filter.orderBy === field) {
      this.vm.filter.isDesc = !this.vm.filter.isDesc;
    } else {
      this.vm.filter.isDesc = false;
    }

    this.vm.filter.orderBy = field;

    this.loadList();
  }

  public onPage(event: any) {   
    this.vm.filter.skip = (event - 1) * this.vm.filter.take;
    this.loadList();
  }

  public onFilterChange(event: any): void {
    this.filterChangeSubj.next(event.target.value);
  }

  public onPaste(event: ClipboardEvent): void {
    let clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedText = clipboardData.getData('text');
    this.filterChangeSubj.next(pastedText);
  }
}